import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "usystech_cookie_consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem(STORAGE_KEY);
    if (!accepted) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="cookie-consent-banner"
      role="dialog"
      aria-label="Aviso sobre uso de cookies"
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        background: "rgba(20, 20, 30, 0.98)",
        color: "#fff",
        padding: "1rem 1.5rem",
        boxShadow: "0 -4px 20px rgba(0,0,0,0.2)",
        zIndex: 9999,
        fontSize: "0.95rem",
      }}
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-8 mb-3 mb-lg-0">
            <p className="mb-0">
              Utilizamos cookies e tecnologias similares para melhorar sua
              experiência, analisar o uso do site e garantir o funcionamento da
              plataforma, em conformidade com a LGPD. Ao continuar, você concorda
              com nosso uso de cookies.{" "}
              <Link to="/politica-de-privacidade" className="text-white text-decoration-underline">
                Política de Privacidade
              </Link>
            </p>
          </div>
          <div className="col-lg-4 text-lg-end">
            <button
              type="button"
              className="btn btn-primary"
              onClick={accept}
              style={{ whiteSpace: "nowrap" }}
            >
              Aceitar e continuar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
